// Import Packages
import React, { useState } from "react";
import { useTranslation } from "react-i18next";


// Import Pages
import { RadioButtons } from "../../../FlowConfigurationInputs";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description this page String Library's CApitalize Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Abdullah Onur Yeşil
 */
export default function Capitalize({
    action,
    variables,
    setOpenVariable,
    variableRender,
    visible
}) {
    const [isCapitalize, setIsCapitalize] = useState(action?.fields?.isCapitalize?.value === 'multiple' ? 'multiple' : 'single');
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.STRING.";
    const options = {
        radioButtons: {
            data: [
                {
                    value: "single",
                    label: label + "ONLY-FIRST-LETTER",
                },
                {
                    value: "multiple",
                    label: label + "MULTIPLE-LETTER",
                },
            ],
            defaultValue: action?.fields?.isCapitalize?.value === 'multiple' ? 'multiple' : 'single',
        },
    };

    const changeCapitalize = (k, v) => {
        if (v.value === 'single') {
            delete action.fields.delimiter;
        }
        setIsCapitalize(v.value);
    }

    return (
        <div>
            <div className={`conf-field-container ${visible ? "display-none" : ""}`}>
                <FieldLabel name={t(label + "SOURCESTRING")} is_required />
                <TextInput
                    action={action}
                    inputName="sourceString"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                    displayName={t(label + "SOURCESTRING")}
                    fieldType={"string"}
                    hideRequired
                />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "CAPITALIZE-IS")} />
                <RadioButtons
                    action={action}
                    inputName="isCapitalize"
                    isRequired={true}
                    options={options.radioButtons}
                    setField={changeCapitalize}
                />
            </div>
            {
                isCapitalize === 'multiple' &&
                <div className="conf-field-container">
                    <FieldLabel name={t(label + "DELIMITER")} is_required />
                    <TextInput
                        action={action}
                        inputName="delimiter"
                        variables={variables}
                        setOpenVariable={setOpenVariable}
                        isRequired
                        displayName={t(label + "DELIMITER")}
                        fieldType={"string"}
                        hideRequired
                    />
                </div>
            }

            <div className={`conf-field-container ${visible ? "display-none" : ""}`}>
                <FieldLabel name={t("CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE")} is_required />
                <VariablePicker
                    action={action}
                    inputName="set"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    isRequired
                    filter="string"
                    hideRequired
                />
            </div>
        </div>
    );
}
